import { useMutation } from 'react-query';

import { ResetPasswordTokenDto } from 'interfaces/authInterface';
import { authService } from 'services';

export default function useMutationActiveAccount() {
  return useMutation((values: ResetPasswordTokenDto) => authService.activeAccount(values));
}
